import Vue from 'vue/dist/vue'
import PermissionsAutocomplete from '../components/permissions_autocomplete.vue'
import Autocomplete from 'v-autocomplete'
import VueResource from 'vue-resource'

Vue.use(Autocomplete)
Vue.use(VueResource)

const app = new Vue({
  components: { PermissionsAutocomplete },
}).$mount('#manage')
